export default "__VITE_ASSET__DUnyBjT$__"